'use client';

import { ProductType } from '@hc-frontend/core-types';
import { createHash } from 'crypto';
import Script from 'next/script';
import React from 'react';

import { getCriteoAccount } from './criteo-utils';

export type CriteoEngagementTagProps = {
  email: string;
  product: ProductType;
  domainSessionId: string | undefined;
  price: number;
};

export function CriteoConversionTag({
  email,
  product,
  domainSessionId,
  price,
}: CriteoEngagementTagProps) {
  const shaHashedEmail = createHash('sha256').update(email).digest('hex');
  const md5HashedEmail = createHash('md5').update(email).digest('hex');
  const accountId = getCriteoAccount(product);
  const transactionId = domainSessionId || '1';

  const scriptContents = `window.criteo_q = window.criteo_q || []; var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d"; window.criteo_q.push( { event: "setAccount", account: ${accountId} }, { event: "setEmail", email: "${shaHashedEmail}", hash_method: "sha256" }, { event: "setEmail", email: "${md5HashedEmail}", hash_method: "md5" }, { event: "setSiteType", type: deviceType }, { event: 'trackTransaction', id: "${transactionId}", item: [{ id: '1', price: ${price}, quantity: 1 }] } );`;

  return (
    <>
      <Script
        id="criteo-conversion-script"
        strategy="afterInteractive"
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: scriptContents,
        }}
      />
    </>
  );
}
